import BaseMap, {
  Marker,
  NavigationControl,
  StyleSwitcher
} from '@portalterreno/react-ui/Map';
import React from 'react';

export type MapProps = {
  latitude: number;
  longitude: number;
  mapPreview?: string;
  zoom?: number;
};

const styleList = [
  {
    mapStyle: 'mapbox://styles/mapbox/satellite-streets-v11',
    text: 'Satélite'
  },
  {
    mapStyle: 'mapbox://styles/mapbox/light-v10',
    text: 'Mapa'
  }
];

const Map: React.FC<MapProps> = ({ latitude, longitude, mapPreview, zoom }) => {
  const [mapStyle, setMapStyle] = React.useState(styleList[0].mapStyle);
  const handleStyleSwitch: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback((e) => {
      setMapStyle(e.currentTarget.value);
    }, []);

  return (
    <BaseMap
      height={375}
      initialViewState={{
        latitude,
        longitude,
        zoom: zoom ?? 14
      }}
      mapboxAccessToken={process.env.NEXT_PUBLIC_MAPBOX_TOKEN}
      mapStyle={mapStyle}
      preview={mapPreview}
    >
      <NavigationControl />
      <StyleSwitcher
        actualMapStyle={mapStyle}
        styleOptions={styleList}
        onClick={handleStyleSwitch}
      />
      <Marker
        latitude={latitude}
        longitude={longitude}
      />
    </BaseMap>
  );
};

export default React.memo(Map);
